module.exports = __webpack_public_path__ + "static/media/crd_icon.4a26e238.png";